import { css, keyframes } from '@emotion/react';

export const InlineLoader: React.FunctionComponent<{}> = () => {
  return (
    <svg
      css={spinner}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9497 12.9497C11.9708 13.9287 10.7235 14.5954 9.36563 14.8655C8.00777 15.1356 6.6003 14.997 5.32122 14.4672C4.04213 13.9373 2.94888 13.0401 2.17971 11.889C1.41054 10.7378 1 9.38447 1 8C1 6.61553 1.41054 5.26215 2.17971 4.11101C2.94888 2.95986 4.04213 2.06266 5.32122 1.53284C6.6003 1.00303 8.00776 0.864407 9.36563 1.1345C10.7235 1.4046 11.9708 2.07128 12.9497 3.05025"
        // TODO: Use accent color here
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

const spinner = css({
  animation: `${spin} linear 800ms infinite`,
});
